<div class="mb-3">
  <div class="d-flex align-items-center justify-content-between border-bottom pb-2">
    <h1 class="fw-light mb-0" data-testid="bookmark-list-heading" i18n="@@bookmarkList.heading">Merkliste</h1>

    @if (catalogItems.length > 0) {
      <button
        class="btn btn-outline-secondary btn-sm"
        type="button"
        data-testid="bookmark-list-clear-button"
        [asyncClick]="clearAll.bind(this)"
        #clearButton="asyncClick"
        [disabled]="clearButton.disabled"
      >
        @if (clearButton.busy) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        <ng-container i18n="@@bookmarkList.clear">Merkliste leeren</ng-container>
      </button>
    }
  </div>

  @if (loading) {
    <div class="d-flex justify-content-center py-5">
      <app-loading-spinner
        text="Merkliste wird geladen…"
        i18n-text="@@bookmarkList.loading"
      ></app-loading-spinner>
    </div>
  } @else if (catalogItems.length === 0) {
    <!-- An empty Merkliste is the normal starting state, not an error — so it says what the
         list is for and offers the way to fill it, rather than leaving an empty container. -->
    <div class="bookmark-list-empty text-center py-5" data-testid="bookmark-list-empty">
      <p class="text-muted mb-3" i18n="@@bookmarkList.empty">
        Sie haben noch keine Artikel gemerkt. Über das Lesezeichen-Symbol auf einem Suchergebnis
        merken Sie sich einen Artikel und finden ihn hier wieder.
      </p>
      <a class="btn btn-primary" [routerLink]="['/search']" i18n="@@bookmarkList.empty.toSearch">
        Artikel suchen
      </a>
    </div>
  } @else {
    <div class="catalog-item-grid mt-4">
      @for (catalogItem of catalogItems; track catalogItem.catalogSku.skuId) {
        <app-catalog-item-card
          [catalogSku]="catalogItem.catalogSku"
          [isBookmarked]="bookmarkedIds.has(catalogItem.catalogSku.skuId)"
          [bookmarkAction]="bookmarkAction(catalogItem.catalogSku.skuId)"
        ></app-catalog-item-card>
      }
    </div>

    <p class="text-muted mt-3" i18n="@@pagedList.countOfTotal">{{ catalogItems.length }} von {{ totalCount }} Einträgen</p>
    @if (catalogItems.length < totalCount) {
      <button class="btn btn-outline-primary" type="button" (click)="loadMore()" [disabled]="loadingMore" i18n="@@pagedList.loadMore">
        @if (loadingMore) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        Mehr laden
      </button>
    }
  }
</div>
